import { useUiStore } from '@features/qc_task_details_view/store/uiStore'
import { Box, Toolbar, AppBar, Stack, Typography, Button } from '@mui/material'

type ReassignExamHeaderProps = {
  subjectPseudoId?: string
  handleClose: () => void
  isSubmitting: boolean
}

function ReassignExamHeader({ subjectPseudoId, handleClose, isSubmitting }: ReassignExamHeaderProps) {
  const { resetUIState } = useUiStore()
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        zIndex: 10,
        width: '100%',
      }}
    >
      <AppBar position="static" sx={{ bgcolor: 'background.default', boxShadow: 2 }}>
        <Toolbar sx={{ justifyContent: 'space-between', minHeight: '56px !important' }}>
          <Stack>
            <Typography color="text.primary" variant="subtitle2">
              Exam reassignment
            </Typography>
            <Typography color="text.secondary" variant="caption">
              Subject {subjectPseudoId}
            </Typography>
          </Stack>
          <Button
            onClick={() => {
              resetUIState()
              handleClose()
            }}
            color="secondary"
            variant="contained"
            size="large"
            disabled={isSubmitting}
          >
            Close
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default ReassignExamHeader
